import { render, staticRenderFns } from "./ganntTaskItem.vue?vue&type=template&id=79d92c8e&"
import script from "./ganntTaskItem.vue?vue&type=script&lang=js&"
export * from "./ganntTaskItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports